import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ANNOUNCEMENTS_ANNOUNCEMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/announcements',
        iconClass: 'fas fa-bullhorn',
        name: '::Menu:Announcements',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Announcements',
      },
    ]);
  };
}
